const mainActions = {

  changeUser (context , user ) {
    context.commit('changeUser', user)
  },

  nullUserObj (context, user) {
    context.commit('nullUserObj', user)
  }

}

export { mainActions }
